/* Casa Manavay · señales de confianza y urgencia en el recuadro de compra (15 oct 2026; precios 16 oct 2026)
   - Señales REALES bajo el botón (stock en Chile, confirmación por WhatsApp). Sin contadores inventados (Ley 19.496).
   - Urgencia (pedido de Nicolás, 15 oct 21:04):
       · Dúo y Triple: "Oferta hasta el 9 de noviembre" con cuenta regresiva siempre visible.
       · Resto de productos: sin oferta con fecha. Urgencia por fecha de entrega: "Pide hoy y recíbelo del X al Y".
   - Preguntas rápidas: todas parten cerradas. */
(function(){
  if(window.cmSenalesOk) return; window.cmSenalesOk = true;
  var FIN = '2026-11-09T23:59:59-03:00';
  var ico = {
    caja: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/></svg>',
    chat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a8 8 0 0 1-11.7 7.1L4 20l1-4.6A8 8 0 1 1 21 12z"/></svg>',
    rayo: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>',
    camion: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>'
  };
  var items = [
    [ico.caja, '<b>Stock disponible</b> · sale desde bodega en Chile'],
    [ico.chat, 'Te confirmamos por <b>WhatsApp</b> en 24 a 48 horas']
  ];
  function estilos(){
    if(document.getElementById('cm-sen-css')) return;
    var st = document.createElement('style'); st.id = 'cm-sen-css';
    st.textContent = '.cm-sen{display:grid;gap:8px;margin:12px 0 2px}'
      + '.cm-sen__it{display:flex;align-items:center;gap:10px;padding:10px 12px;border:1px solid rgba(255,255,255,.16);border-radius:10px;background:rgba(255,255,255,.02);font:500 13.5px/1.3 Inter,system-ui,sans-serif;color:rgba(255,255,255,.85);text-align:left}'
      + '.cm-sen__it b{color:#fff;font-weight:700}'
      + '.cm-sen__it svg{flex:0 0 20px;width:20px;height:20px;color:#C8F135}'
      + '.cmu{margin:0 0 14px;padding:13px 15px;border-radius:12px;font-family:Inter,system-ui,sans-serif;text-align:left}'
      + '.cmu--oferta{background:#C8F135;color:#0D0D0D}'
      + '.cmu--oferta .cmu__t{display:flex;align-items:center;gap:8px;font:900 20px/1 "Barlow Condensed","Arial Narrow",sans-serif;letter-spacing:.06em;text-transform:uppercase}'
      + '.cmu--oferta .cmu__t svg{width:18px;height:18px}'
      + '.cmu--oferta .cmu__r{margin-top:8px;font:700 13.5px/1.3 Inter,sans-serif}'
      + '.cmu--oferta .cmu__r strong{font:900 26px/1 "Barlow Condensed","Arial Narrow",sans-serif;font-variant-numeric:tabular-nums;letter-spacing:.02em;margin-left:4px}'
      + '.cmu--oferta .cmu__x{margin-top:6px;font-size:13px;line-height:1.4}'
      + '.cmu--entrega{display:flex;align-items:center;gap:12px;border:1.5px solid #C8F135;background:rgba(200,241,53,.08);color:#fff}'
      + '.cmu--entrega svg{flex:0 0 26px;width:26px;height:26px;color:#C8F135}'
      + '.cmu--entrega b{display:block;font:900 18px/1.1 "Barlow Condensed","Arial Narrow",sans-serif;letter-spacing:.04em;text-transform:uppercase;color:#C8F135}'
      + '.cmu--entrega span{display:block;margin-top:3px;font-size:13px;line-height:1.35;color:rgba(255,255,255,.75)}'
      + '.cmu__envio{display:flex;align-items:center;gap:8px;margin-top:9px;padding-top:9px;border-top:1px solid rgba(0,0,0,.18);font-size:13px}'
      + '.cmu__envio svg{width:17px;height:17px}';
    document.head.appendChild(st);
  }
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function rangoEntrega(){
    var u = document.querySelector('.cm-urg__envio b');
    return u ? u.textContent : '';
  }
  var nU = 0;
  function urgencia(){
    var u = document.querySelector('.cm-buy .cm-urg');
    if(!u){ if(nU++ < 80){ setTimeout(urgencia, 250); } return; }
    if(u.getAttribute('data-cmu')) return;
    u.setAttribute('data-cmu', '1');
    var rango = rangoEntrega();
    var fin = new Date(FIN).getTime();
    var nuevo = document.createElement('div');
    if(window.cmSinCierre && Date.now() < fin){
      var esDuo = /duo/i.test(location.pathname);
      nuevo.className = 'cmu cmu--oferta';
      nuevo.innerHTML = '<div class="cmu__t">' + ico.rayo + 'Oferta hasta el 9 de noviembre</div>'
        + '<div class="cmu__r">Termina en <strong data-cmu-reloj></strong></div>'
        + '<div class="cmu__x">' + (esDuo ? 'Dúo a <b>$34.990</b>: ahorras $14.990 frente a comprarlos por separado.' : 'Triple a <b>$42.990</b>: $14.330 por frasco, ahorras $31.980.') + '</div>'
        + (rango ? '<div class="cmu__envio">' + ico.camion + '<span>Si lo pides hoy, te llega del <b>' + rango + '</b></span></div>' : '');
      u.parentNode.replaceChild(nuevo, u);
      var rel = nuevo.querySelector('[data-cmu-reloj]');
      var t;
      var tick = function(){
        var resta = fin - Date.now();
        if(resta <= 0){ nuevo.style.display = 'none'; clearInterval(t); return; }
        var s = Math.floor(resta / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sg = s % 60;
        rel.textContent = (d > 0 ? d + (d === 1 ? ' día ' : ' días ') : '') + pad(h) + ':' + pad(m) + ':' + pad(sg);
      };
      tick(); t = setInterval(tick, 1000);
    } else {
      if(!rango){ u.parentNode.removeChild(u); return; }
      nuevo.className = 'cmu cmu--entrega';
      nuevo.innerHTML = ico.camion + '<div><b>Pide hoy y recíbelo del ' + rango + '</b><span>Despacho desde bodega en Chile. Mientras antes confirmes, antes sale.</span></div>';
      u.parentNode.replaceChild(nuevo, u);
    }
  }
  function cerrarPreguntas(){
    document.querySelectorAll('.lp-faq details[open], .faq__item[open]').forEach(function(d){ d.removeAttribute('open'); });
  }
  var n = 0;
  function armar(){
    var buy = document.querySelector('.cm-buy');
    var w = buy && buy.querySelector('.rsi_embedded_quantity_wrapper');
    if(!w){ if(n++ < 80){ setTimeout(armar, 250); } return; }
    estilos();
    urgencia();
    if(buy.querySelector('.cm-sen')) return;
    var d = document.createElement('div'); d.className = 'cm-sen';
    items.forEach(function(x){ d.innerHTML += '<div class="cm-sen__it">' + x[0] + '<span>' + x[1] + '</span></div>'; });
    w.parentNode.insertBefore(d, w.nextSibling);
  }
  function iniciar(){ cerrarPreguntas(); armar(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', iniciar); } else { iniciar(); }
})();